import React, { useState } from 'react';
import './App.scss';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Home from './pages/Home/Home';
import Login from './pages/Login/login';
import Unauthorized from './components/Unauthorized/Unauthorized';
import ProtectedRoute from './components/ProtectedRoute/ProtectedRoute';
import IntelligentDocManagement from './pages/IntelligentDocManagement/IntelligentDocManagement';
import Sidebar from './components/Sidebar/Sidebar';
import Navbar from './components/Navbar/Navbar';
import PageNotFound from './components/PageNotFound/PageNotFound';
import Benchmarking from './pages/Benchmarking/Benchmarking';
import SessionTimeout from './components/SessionTimeout/SessionTimeout';
import Logout from './pages/Logout/Logout';
import IdleTimer from './components/IdleTimer/IdleTimer';
import UserSessionTimeout from './components/UserSessionTimeout/UserSessionTimeout';
import Help from './pages/Help/Help';
import DraftGenerationMain from './pages/DraftGenerationMain/DraftGenerationMain';
const App: React.FC = () => {
  const [name, setName] = useState('')

  return (
    <>
      <div className='home-wrapper'>
        <Router>
          <Navbar name={name} />
          <div className='main-wrapper'>
            <Sidebar />
            <div className='content'>
              <Routes>
                <Route path='/' element={<Login />} />
                <Route path='/home' element={<Home />} />
                <Route path="/docmanagement" element={<ProtectedRoute requiredRoles={['idm']}><IntelligentDocManagement /></ProtectedRoute>} />
                <Route path="/draftgeneration" element={<ProtectedRoute requiredRoles={['dg']}>< DraftGenerationMain /></ProtectedRoute>} />
                <Route path="/benchmarking" element={<ProtectedRoute requiredRoles={['benchmarking']}><Benchmarking /></ProtectedRoute>} />
                <Route path="/help" element={<ProtectedRoute requiredRoles={['help']}><Help /></ProtectedRoute>} />
                <Route path='/login' element={<Login />} />
                <Route path='/logout' element={<Logout />} />
                <Route path='/unauthorized' element={<Unauthorized />} />
                <Route path="*" element={<PageNotFound />} />
              </Routes>
              <UserSessionTimeout />
              <SessionTimeout />
              <IdleTimer />
            </div>
          </div>
        </Router>

      </div>
    </>
  );
};

export default App;
